module.exports = __webpack_public_path__ + "static/media/step1_14_m.afec298c.png";